import React, { Component, useState } from "react";
//import { Link, useParams } from "react-router-dom";
import Sidebar from "shared/components/Sidebar/Sidebar";
import background from "assets/backgrounds/01.jpg";
import "./styles.css";
import basica from "../../../../../src/assets/entrega_domicilio/basica.png";
import estandar from "../../../../../src/assets/entrega_domicilio/estandar.png";
// import alto_ico from "../../../../../src/assets/product/formats/alto.png";
// import ancho_ico from "../../../../../src/assets/product/formats/ancho.png";
// import bulto_ico from "../../../../../src/assets/product/formats/bulto.png";
// import peso_ico from "../../../../../src/assets/product/formats/peso.png";
// import profundidad_ico from "../../../../../src/assets/product/formats/profundidad.png";
// import valor_declarado_ico from "../../../../../src/assets/product/formats/valor-declarado.png";
import Formulario from "./components/Formulario";
import TiposServicios from "./components/TiposServicios";
import DatosRemitente from "./components/DatosRemitente";
import DatosDestinatario from "./components/DatosDestinatario";
import ConfirmarDatos from "./components/ConfirmarDatos";
import FomularioPago from "./components/FomularioPago";
import FomularioPagoProcesar from "./components/FomularioPago";
import PagoProcesado from "./components/PagoProcesado";
import Tarjetas from "./components/Tarjetas";

import PickUpFormulario from "../PickUpFormulario/index";

import axios from "axios";
import Modal from "simple-react-modal";
//import Form from './Form/Form'

import {
  Accordion,
  Card,
  Col,
  Button,
  Form,
  CardGroup,
  Transitions,
  Collapse
} from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";

class PickUp extends Component {
  componentWillMount() {
    /*let importe_declarado = `/api/importe_declarado`;

    axios.get(importe_declarado, "")
    .then(response  => {
        let { data } = response;
        //console.log(data)
        console.log(data)
        this.setState({Importes:data})
        
    })
    .catch(e => {

        this.setState({
          //infoPago: e.response.data.message,
          xhr: false,
          ////showModal: true,
          errorMessage: "server-error: "+e.response.data.message
        });              
        
        console.log(e);
    });*/
  }

  constructor(props) {
    super(props);

    let code = "";
    if (props.match.params && props.match.params.code) {
      code = props.match.params.code;
    }

    let title = "";
    let description = "";
    let valid = false;

    switch (code) {
      case "rd":
        title = "Retiro en domicilio";
        description = "Cotizador de retiros a domicilio.";
        valid = true;
        break;
      case "ea":
        title = "Pickup en agencia";
        description = "";
        valid = true;
        break;

      case "pm":
        title = "Pickup móvil";
        description = "";
        valid = true;
        break;
      default:
        title = "";
        description = "";
        break;
    }
    console.log(title);

    if (!valid) {
      this.props.history.push("/");
    }

    this.state = {
      title: title,
      description: description,
      productCode: code,
      activeId: 1123,
      setActiveId: 1,
      open1: false,
      open1once: true, //Tarea GDM-1293
      open2: false,
      open3: false,
      open4: false,
      open5: false,
      open6: false,
      open7: false,
      selectedOption: 0, //Tarea GDM-1031
      error: {
        cporigen: ""
      },
      validated: "aki",
      tiposServicios: {},
      message: "",
      showModal: false,
      errorMessage: "",
      modalMessage: "",
      xhr: true,

      IdCotizacion: 0,
      DescripcionServicio: "",
      CodigoServicio: 0,
      TotalServicio: 0,
      TipoEntrega: "",
      NumeroBultos: 0,
      Kilos: 0,
      Alto: 0,
      Ancho: 0,
      CodigoPostalRemitente: 0,
      CodigoPostalDestinatario: 0,
      ImporteValorDeclarado: 0,
      Pago: "",

      camposFormulario: {},
      datosRemitente: {},
      datosDestinatario: {},

      NombreRemitente: "",
      DireccionRemitente: "",
      /*Numero:"",
      CodigoPostal:"",
      Piso:"",
      DatosAdicional:"",*/
      NroDocRemitente: "",
      TelefonoRemitente: "",
      EmailRemitente: "",

      NombreDestinatario: "",
      DireccionDestinatario: "",
      /*Numero:"",
      CodigoPostal:"",
      Piso:"",
      DatosAdicional:"",*/
      NroDocDestinatario: "",
      TelefonoDestinatario: "",
      EmailDestinatario: "",

      IdTarjeta: "",
      IdPosnet: "",
      Cuotas: "",
      Coeficiente: "",

      urlIframe: "",
      infoFirstData: {},
      formPago: {},
      idEnvio: "",
      infoPago: undefined,
      intervalo: undefined,
      costoFijo: "",
      Importes: {},
      confirmar: true, //Tarea GDM1031
      limpiar: false //Tarea GDM1031
    };
  }
  timeoutImprimir = 0;
  contador = 0;
  intentosImprimir = 0;
  token = sessionStorage.getItem("token");

  timeout = 0;
  intentos = 0;

  checkToken() {
    if (
      !sessionStorage.getItem("token") &&
      !sessionStorage.getItem("timestamp")
    ) {
      axios.get(process.env.REACT_APP_API_URL + "/api/token").then(res => {
        if (
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
            res.data
          )
        ) {
          sessionStorage.setItem("token", res.data);
          sessionStorage.setItem("timestamp", new Date());

          this.token = res.data;
          return res.data;
        }
      });
    } else {
      const now = new Date();
      const tokenTimestamp = new Date(sessionStorage.getItem("timestamp"));
      const diffTime = Math.abs(tokenTimestamp - now);
      const diffMin = Math.round(((diffTime % 86400000) % 3600000) / 60000);
      if (diffMin > 60) {
        axios.get(process.env.REACT_APP_API_URL + "/api/token").then(res => {
          if (
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
              res.data
            )
          ) {
            sessionStorage.setItem("token", res.data);
            sessionStorage.setItem("timestamp", new Date());

            this.token = res.data;
            return res.data;
          }
        });
      } else {
        return sessionStorage.getItem("token");
      }
    }
  }

  toggleActive(id) {
    if (this.state.activeId === id) {
      this.setState({ setActiveId: null });
    } else {
      this.setState({ setActiveId: id });
    }
  }

  setOpen(valor, indice) {
    switch (indice) {
      case 1:
        /*Tarea GDM-1293 - Inicio */
        if (this.state.open1once) {
          this.setState({ open1: valor });
          this.setState({ open1once: false });
        }
        /*Tarea GDM-1293 - Fin */
        break;
      case 2:
        this.setState({ open2: valor });
        break;

      case 3:
        this.setState({ open3: valor });
        break;

      case 4:
        this.setState({ open4: valor });
        break;

      case 5:
        this.setState({ open5: valor });
        break;

      case 6:
        this.setState({ open6: valor });
        break;

      case 7:
        this.setState({ open7: valor });
        break;

      default:
        return "";
    }
  }

  consultarPago = () => {
    if (this.state.idEnvio) {
      let camposFirstData = {
        IdOperacion: this.state.idEnvio, //3374303, //formulario.oid,
        IdClienteRemitente: "99999999",
        NombreRemitente: "Test",
        DireccionRemitente: "Test",
        TipoDocRemitente: "DNI",
        NroDocRemitente: "1234567"
      };

      let retiros_actualizar_pago = `process.env.REACT_APP_API_URL/api/retiros_actualizar_pago`;

      axios
        .post(retiros_actualizar_pago, camposFirstData, {
          params: { token: this.token }
        })
        .then(response => {
          let { data } = response;

          this.setState({ infoPago: data.data });
          //console.log(this.state.infoPago)
          ///props.actualizarPago(data.data)
          ////setUrl("/pickup-formulario/"+encodeURIComponent( JSON.stringify(response.data.data.Pago)))
          if (data.status && data.data.message == "Pago aprobado") {
            clearInterval(this.timeout);
          }
        })
        .catch(e => {
          this.setState({
            //infoPago: e.response.data.message,
            xhr: false,
            ////showModal: true,
            errorMessage: "server-error: " + e.response.data.message
          });

          console.log(e);
        });

      this.intentos++;

      if (this.intentos > 1) {
        const v = { data: "Ford" };
        clearInterval(this.timeout);
        this.setState({ infoPago: v });
      }
    }
  };

  actualizarPago = valores => {
    this.setState({ idEnvio: valores });

    var consulta = undefined;
  };

  tiposServicios(campos) {
    this.setState({ NumeroBultos: campos.NumeroBultos });
    this.setState({ Kilos: campos.Kilos });
    this.setState({ Largo: campos.Largo });
    this.setState({ Alto: campos.Alto });
    this.setState({ Ancho: campos.Ancho });
    this.setState({ CodigoPostalRemitente: campos.CodigoPostalRemitente });
    this.setState({
      CodigoPostalDestinatario: campos.CodigoPostalDestinatario
    });
    this.setState({ ImporteValorDeclarado: campos.ImporteValorDeclarado });
    this.setState({ Pago: campos.Pago });

    this.setState({ open2: true });
    this.setState({ open1: false });

    let cotizarPost = process.env.REACT_APP_API_URL + `/api/cotizar`;
    axios
      .post(cotizarPost, campos, { params: { token: this.token } })
      .then(response => {
        let { data } = response;
        //console.log(data)

        this.setState((state, props) => ({
          tiposServicios: data
        }));

        this.setState({ open2: true });
        this.setState({ open1: false });
      })
      .catch(e => {
        this.setState({
          xhr: false,
          showModal: true,
          errorMessage: "server-error: " + e.response.data.message
        });
        this.atrasForm1();
        console.log(e);
      });
    /*Tarea GDM-1031 - Inicio */

    let datosCampos = { ...campos };
    datosCampos.Volumen =
      (datosCampos.Alto * datosCampos.Ancho * datosCampos.Largo) / 1000000;
    datosCampos.TipoPortes = datosCampos.Pago;
    delete datosCampos.CodigoPostalRemitente;
    delete datosCampos.CodigoPostalDestinatario;
    delete datosCampos.Pago;
    window.localStorage.setItem("datosRemitente", JSON.stringify(datosCampos));
    /*Tarea GDM-1031 - Fin */
  }

  retiros = valores => {
    this.timeoutImprimir = setInterval(() => {
      imprimir(valores);
    }, 5000);

    const imprimir = valores => {
      if (this.contador > 3) {
        clearInterval(this.timeoutImprimir);
        //console.log("a");
        this.setState({
          //infoPago: e.response.data.message,
          xhr: false,
          ////showModal: true,
          errorMessage: "server-error: Error al imprimir"
        });
      } else {
        let sumar = this.intentosImprimir + 1;
        this.intentosImprimir = sumar;
        this.contador++;

        let retiros = process.env.REACT_APP_API_URL + `/api/retiros`;
        axios
          .post(retiros, {}, { params: { token: this.token } })
          .then(response => {
            let { data } = response;
            clearInterval(this.timeoutImprimir);
          })
          .catch(e => {
            this.setState({
              xhr: false,
              showModal: true,
              errorMessage: "server-error: " + e.response.data.message
            });
            //console.log(e);
          });
      }
    };
  };

  atrasForm1 = () => {
    this.setState({ open1: true });
    this.setState({ open2: false });
  };

  atrasForm2 = () => {
    this.setState({ open2: true });
    this.setState({ open3: false });
  };

  atrasForm3 = () => {
    this.setState({ open3: true });
    this.setState({ open4: false });
  };

  atrasForm4 = () => {
    this.setState({ open4: true });
    this.setState({ open5: false });
  };

  atrasForm6 = () => {
    this.setState({ open5: true });
    this.setState({ open6: false });
  };

  atrasForm7 = () => {
    this.setState({ open6: true });
    this.setState({ open7: false });
  };

  segundoForm = valores => {
    this.setState({ camposFormulario: valores });
    this.tiposServicios(valores);
  };

  tercerForm = () => {
    this.setState({ open3: true });
    this.setState({ open2: false });
  };

  cuartoForm = () => {
    this.setState({ open4: true });
    this.setState({ open3: false });
  };

  quintoForm = () => {
    this.setState({ open5: true });
    this.setState({ open4: false });
  };

  sextoForm = () => {
    this.setState({ open7: true }); //Tarea GDM-1031
    //this.setState({ open5: false });//Tarea GDM-1031
  };

  septimoForm = () => {
    this.setState({ open7: true });
    this.setState({ open6: true });
  };

  aceptarForm = valor => {
    this.setState({ aceptar: valor });
  };
  /*Tarea GDM-1031 - Inicio */
  limpiarForm() {
    for (let i = 0; i < document.getElementsByTagName("form").length; i++) {
      document.getElementsByTagName("form")[i].reset();
    }
  }
  volverForm = () => {
    this.setState({ limpiar: true });
    this.limpiarForm();
    this.setState({ open1: false });
    this.setState({ open2: false });
    this.setState({ open3: false });
    this.setState({ open4: false });
    this.setState({ open5: false });
    this.setState({ open6: false });
    this.setState({ open7: false });
  };
  ocultarConfirmar = () => {
    this.setState({ confirmar: false });
  };
  /*Tarea GDM-1031 - Fin */
  parametroSegundoForm = valores => {
    this.setState({ IdCotizacion: valores.Id });
    this.setState({ DescripcionServicio: valores.DescripcionServicio });
    this.setState({ CodigoServicio: valores.Codigo });
    this.setState({ TotalServicio: valores.Total });
    this.setState({ TipoEntrega: valores.TipoEntrega });
  };

  parametroRemitente = valores => {
    valores.DireccionRemitente = valores.DireccionRemitente.replace(/"/g, "");
    valores.NombreRemitente = valores.NombreRemitente.replace(/"/g, "");
    this.setState({ NombreRemitente: valores.NombreRemitente });
    this.setState({ DireccionRemitente: valores.DireccionRemitente });
    this.setState({ NroDocRemitente: valores.NroDocRemitente });
    this.setState({ TelefonoRemitente: valores.TelefonoRemitente });
    this.setState({ EmailRemitente: valores.EmailRemitente });
    this.setState({ datosRemitente: valores });
    /*Tarea GDM-1031 - Inicio */
    let datosRetiroRemitente = JSON.parse(
      window.localStorage.getItem("datosRemitente")
    );
    let datosRemi = { ...valores };
    datosRemi.DireccionRemitente =
      datosRemi.DireccionRemitente +
      " Numero : " +
      datosRemi.Numero +
      " " +
      "Piso : " +
      datosRemi.Piso +
      "  Observacion: " +
      datosRemi.DatosAdicional;
    datosRemi.CodigoPostalRemitente = datosRemi.CodigoPostal;
    datosRemi.TipoDocRemitente = "DNI";
    datosRemi.IdClienteRemitente = "99999999";
    datosRemi.IdCentroRemitente = "99";
    delete datosRemi.DatosAdicional;
    delete datosRemi.Numero;
    delete datosRemi.CodigoPostal;
    delete datosRemi.Piso;
    datosRemi = { ...datosRetiroRemitente, ...datosRemi };
    window.localStorage.setItem("datosRemitente", JSON.stringify(datosRemi));
    /*Tarea GDM-1031 - Fin */
  };

  parametroDestinatario = valores => {
    valores.DireccionDestinatario = valores.DireccionDestinatario.replace(
      /"/g,
      ""
    );
    valores.NombreDestinatario = valores.NombreDestinatario.replace(/"/g, "");
    this.setState({ NombreDestinatario: valores.NombreDestinatario });
    this.setState({ DireccionDestinatario: valores.DireccionDestinatario });
    this.setState({ NroDocDestinatario: valores.NroDocDestinatario });
    this.setState({ TelefonoDestinatario: valores.TelefonoDestinatario });
    this.setState({ EmailDestinatario: valores.EmailDestinatario });
    this.setState({ datosDestinatario: valores });
    /*Tarea GDM-1031 - Inicio */

    let datosRetiroDestinatario = JSON.parse(
      window.localStorage.getItem("datosRemitente")
    );
    let datosDesti = { ...valores };
    datosDesti.DireccionDestinatario =
      datosDesti.DireccionDestinatario +
      " Numero : " +
      datosDesti.Numero +
      " " +
      "Piso : " +
      datosDesti.Piso +
      " Observacion: " +
      datosDesti.DatosAdicional;
    datosDesti.CodigoPostalDestinatario = datosDesti.CodigoPostal;
    datosDesti.TipoDocDestinatario = "DNI";
    datosDesti.IdClienteDestinatario = "99999999";
    datosDesti.IdCentroDestinatario = "99";
    delete datosDesti.DatosAdicional;
    delete datosDesti.Numero;
    delete datosDesti.CodigoPostal;
    delete datosDesti.Piso;
    datosDesti = { ...datosRetiroDestinatario, ...datosDesti };
    window.localStorage.setItem("datosRemitente", JSON.stringify(datosDesti));
    /*Tarea GDM-1031 - Fin */
  };

  parametroTarjeta = valores => {
    this.setState({ IdTarjeta: valores.IdTarjeta });
    this.setState({ IdPosnet: valores.IdPosnet });
    this.setState({ Cuotas: valores.Cuotas });
    this.setState({ Coeficiente: valores.Coeficiente });
  };

  setOpenClose(valor, indice) {
    if (indice == 2) {
      this.setState({ open2: valor });
      this.setState({ open1: !valor });
    } else if (indice == 3) {
      this.setState({ open3: valor });
      this.setState({ open2: !valor });
    }
  }

  handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.setState({ validated: true });
  };

  setearIntervalo(valor) {
    this.setState({ intervalo: valor });
  }

  render() {
    let { activeId, setActiveId } = this.state;
    let valor = "'" + activeId + "'";

    const formulario = Object.entries(this.state.formPago).map(
      ([key, value]) => {
        let i = 0;
        return <input key={i++} type="text" name={key} value={value}></input>;
      }
    );

    const formularioPago = () => {
      return;
    };

    const valorIframe = formularioPago;

    return (
      <div>
        <Modal
          show={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          className={"modal"}
          containerClassName={"modal-container"}
        >
          <div className={"close-button"}>
            <i
              className={"material-icons"}
              onClick={() => this.setState({ showModal: false })}
            >
              close
            </i>
          </div>
          <div className={"modal-body"}>
            {this.state.modalMessage}
            {this.state.errorMessage}
            <div>
              <button
                className="quote btn btn-default"
                onClick={() => this.setState({ showModal: false })}
              >
                Cerrar
              </button>
            </div>
          </div>
        </Modal>

        <section className="screen-contents faqs-screen">
          <div className="background">
            <img src={background} alt="Fondo" />
          </div>
          <div className="details-container">
            <div className="content">
              <div className="content-title">
                <h1>{this.state.title}</h1>
              </div>
              <div className="content-description">
                <p>{this.state.description}</p>
                <p>La vía más rápida y segura para hacer tus envíos.</p>
              </div>
              <div>
                <Card>
                  <Card.Header
                    onClick={() => this.setOpen(!this.state.open1, 1)}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open1}
                  >
                    1- Comenzá a gestionar
                  </Card.Header>
                  <Collapse in={this.state.open1}>
                    <Card.Body>
                      {/*<Button style={{height:10}}
                          onClick={() => this.setOpenClose(!this.state.open2, 2)}
                          //aria-controls="example-collapse-text"
                          //aria-expanded={this.state.open2}
                        >
                          siguiente
                        </Button>*/}
                      <Formulario
                        codigoProducto={this.state.productCode}
                        titulo={this.state.title}
                        titleDescription={this.state.description}
                        actual={() => this.setOpen(!this.state.open1, 1)}
                        tiposServicios={this.segundoForm}
                        checkToken={this.checkToken}
                        limpio={this.state.limpiar} //Tarea GDM1031
                        //Importes = {this.state.Importes}
                      />
                    </Card.Body>
                  </Collapse>
                </Card>

                <Card>
                  <Card.Header
                    //onClick={() => this.setOpen(!this.state.open2, 2)}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open2}
                  >
                    2- Tipo de servicio
                  </Card.Header>
                  <Collapse in={this.state.open2}>
                    <Card.Body>
                      {this.state.tiposServicios && (
                        <TiposServicios
                          tiposServicios={this.state.tiposServicios}
                          actual={() => this.setOpen(!this.state.open1, 1)}
                          parametroSegundoForm={this.parametroSegundoForm}
                          tercerForm={this.tercerForm}
                          atrasForm1={this.atrasForm1}
                          checkToken={this.checkToken}
                        />
                      )}
                    </Card.Body>
                  </Collapse>
                </Card>

                <Card>
                  <Card.Header
                    //onClick={() => this.setOpen(!this.state.open3, 3)}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open3}
                  >
                    3- Datos del remitente
                  </Card.Header>
                  <Collapse in={this.state.open3}>
                    <Card.Body>
                      {this.state.tiposServicios && (
                        <DatosRemitente
                          cuartoForm={this.cuartoForm}
                          atrasForm2={this.atrasForm2}
                          parametroRemitente={this.parametroRemitente}
                          CodigoPostalRemitente={
                            this.state.CodigoPostalRemitente
                          }
                        />
                      )}
                    </Card.Body>
                  </Collapse>
                </Card>

                <Card>
                  <Card.Header
                    //onClick={() => this.setOpen(!this.state.open3, 3)}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open4}
                  >
                    4- Datos del destinatario
                  </Card.Header>
                  <Collapse in={this.state.open4}>
                    <Card.Body>
                      {this.state.tiposServicios && (
                        <DatosDestinatario
                          quintoForm={this.quintoForm}
                          atrasForm3={this.atrasForm3}
                          parametroDestinatario={this.parametroDestinatario}
                          CodigoPostalDestinatario={
                            this.state.CodigoPostalDestinatario
                          }
                        />
                      )}
                    </Card.Body>
                  </Collapse>
                </Card>

                <Card>
                  <Card.Header
                    //onClick={() => this.setOpen(!this.state.open5, 5)}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open5}
                  >
                    5- Confirmar datos
                  </Card.Header>
                  <Collapse in={this.state.open5}>
                    <Card.Body>
                      {this.state.tiposServicios && this.state.confirmar && (
                        <ConfirmarDatos
                          sextoForm={this.sextoForm}
                          atrasForm4={this.atrasForm4}
                          DescripcionServicio={this.state.DescripcionServicio}
                          TipoEntrega={this.state.TipoEntrega}
                          Alto={this.state.camposFormulario.Alto}
                          Ancho={this.state.camposFormulario.Ancho}
                          Largo={this.state.camposFormulario.Largo}
                          NumeroBultos={
                            this.state.camposFormulario.NumeroBultos
                          }
                          TotalServicio={this.state.TotalServicio}
                          datosRemitente={this.state.datosRemitente}
                          datosDestinatario={this.state.datosDestinatario}
                          aceptarForm={this.aceptarForm}
                          retiros=""
                          tiposServicios={this.state.tiposServicios}
                        />
                      )}
                      {this.state.open6 && (
                        <div>
                          {this.state.infoPago === undefined && (
                            <Tarjetas
                              septimoForm={this.septimoForm}
                              atrasForm6={this.atrasForm6}
                              parametroTarjeta={this.parametroTarjeta}
                            />
                          )}
                        </div>
                      )}
                      {this.state.open7 && (
                        <div style={{ marginTop: "20px" }}>
                          {this.state.infoPago === undefined && (
                            <FomularioPago
                              formPago={this.state.formPago}
                              importe={this.state.TotalServicio}
                              actualizarPago={this.actualizarPago}
                              NombreRemitente={this.state.NombreRemitente}
                              DireccionRemitente={this.state.DireccionRemitente}
                              NroDocRemitente={this.state.NroDocRemitente}
                              Email={this.state.EmailRemitente}
                              IdTarjeta={this.state.IdTarjeta}
                              IdPosnet={this.state.IdPosnet}
                              Cuotas={this.state.Cuotas}
                              Coeficiente={this.state.Coeficiente}
                              atrasForm7={this.atrasForm7}
                              retiros={this.retiros}
                              data={this.state}
                              volverForm={this.volverForm}
                              ocultarConfirmar={this.ocultarConfirmar}
                            />
                          )}
                          {/* this.state.infoPago && this.state.infoPago.data  && <PagoProcesado 
                        formPago={this.state.infoPago} 
                        importe="1000" 
                        senderFullName={this.state.NombreRemitente}
                        DireccionRemitente={this.state.DireccionRemitente}
                        NroDocRemitente={this.state.NroDocRemitente}
                        NroDocRemitente={this.state.NroDocRemitente}
                        />*/}
                          {/*  <PickUpFormulario info="aki"/>*/}
                        </div>
                      )}
                    </Card.Body>
                  </Collapse>
                </Card>
              </div>
            </div>
            <Sidebar />
          </div>
        </section>
      </div>
    );
  }
}

export default PickUp;
